(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["sequenced_accessions"] = factory();
	else
		root["jsMod"] = root["jsMod"] || {}, root["jsMod"]["sequenced_accessions"] = factory();
})(window, function() {
return 